import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function managementsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('data', null).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', mapManagements(action.payload));
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}

function mapManagements(managements = []) {
  const managementsMap = {};
  managements.map((management) => {
    managementsMap[management.id] = management;
  });

  return Map(managementsMap);
}
